import api from "./apiBase";

const MODULE = "admin";

function getUserByAdmin(id) {
  return api.get(`${MODULE}/user?id=${id}`);
}

function updateDataByAdmin({ module, id, data }) {
  return api.patch(`${MODULE}?q=${module}&id=${id}`, data);
}

function getModelReports({
  page = 1,
  limit = 10,
  search = "",
  sortBy = "",
  sortOrder = "",
}) {
  const params = new URLSearchParams();
  if (page) params.append("page", page);
  if (limit) params.append("limit", limit);
  if (search) params.append("search", search);
  if (sortBy) params.append("sortBy", sortBy);
  if (sortOrder) params.append("sortOrder", sortOrder);

  return api.get(`${MODULE}/maker-reports?${params.toString()}`);
}

function calculateDesignCost(payload) {
  // payload: { filamentType: string, weightInGrams: number, printTimeInMinutes: number }
  return api.post("/designs/calculate-cost", payload);
}

function getPrintersRequested({
  page = 1,
  limit = 10,
  search = "",
  sortBy = "",
  sortOrder = "",
}) {
  const params = new URLSearchParams();
  if (page) params.append("page", page);
  if (limit) params.append("limit", limit);
  if (search) params.append("search", search);
  if (sortBy) params.append("sortBy", sortBy);
  if (sortOrder) params.append("sortOrder", sortOrder);

  return api.get(`${MODULE}?q=printersRequested&${params.toString()}`);
}

function getAdminData({
  endpoint = "",
  module,
  page = 1,
  limit = 10,
  search = "",
  filter = "",
  sortBy = "",
  sortOrder = "",
}) {
  const params = new URLSearchParams();
  if (module) params.append("q", module);
  if (page) params.append("page", page);
  if (limit) params.append("limit", limit);
  if (search) params.append("search", search);
  if (filter) params.append("filter", filter);
  if (sortBy) params.append("sortBy", sortBy);
  if (sortOrder) params.append("sortOrder", sortOrder);

  const url = endpoint
    ? `${MODULE}/${endpoint}?${params.toString()}`
    : `${MODULE}?${params.toString()}`;

  return api.get(url);
}

function changeOrderStatus(orderId, newStatus) {
  return api.patch(`${MODULE}/order/${orderId}`, { status: newStatus });
}

function confirmCommissionPayment(systemIdentifier) {
  return api.post(`${MODULE}/commissioning/${systemIdentifier}`);
}

function updateDesignHotScore(designId, hotScore) {
  return api.post(`${MODULE}/designs/${designId}/hot-score`, { hotScore });
}

function getUnfinishedOrders() {
  return api.get(`${MODULE}/open-orders`);
}

function createAdminData({ module, data, endpoint = "" }) {
  const url = endpoint
    ? `${MODULE}/${endpoint}`
    : module === "coupons"
    ? `${MODULE}/coupons`
    : `${MODULE}?q=${module}`;

  const payload = JSON.parse(JSON.stringify(data));

  return api.post(url, payload);
}

function updateCouponActive(couponId, isActive) {
  return api.patch(`${MODULE}/coupons/${couponId}/active`, { isActive });
}

function getCouponFull(couponId) {
  return api.get(`${MODULE}/coupons/${couponId}`);
}

/**
 * Gera nome/descrições via IA (OpenAI com fallback Gemini)
 */
async function generateDesignCopy(payload) {
  const res = await api.post("/admin/ai/generate-description", payload);
  return res.data;
}

function getExternalDesignProductsByDesignId(designId) {
  return api.get(`/connector-design-products/design/${designId}`);
}

function syncExternalOrdersBatch({
  page = 1,
  useExternalPriceFromIntegration = true,
  connectorId,
} = {}) {
  return api.post(
    `/external-orders-maps/nuvemshop/${connectorId}/orders/sync`,
    {
      page,
      useExternalPriceFromIntegration,
    }
  );
}

function getNuvemshopStoreCategories() {
  return api.get(`/connectors/nuvemshop/store-categories`);
}

export {
  calculateDesignCost,
  getAdminData,
  getUserByAdmin,
  updateDataByAdmin,
  changeOrderStatus,
  confirmCommissionPayment,
  getModelReports,
  updateDesignHotScore,
  getPrintersRequested,
  getUnfinishedOrders,
  createAdminData,
  updateCouponActive,
  getCouponFull,
  generateDesignCopy,
  syncExternalOrdersBatch,
  getExternalDesignProductsByDesignId,
  getNuvemshopStoreCategories,
};
